async function fetchIp() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch {
    return null;
  }
}

export function detectOSType() {
  try {
    let osType = null;
    const userAgent = navigator.userAgent;

    if (navigator.appVersion.indexOf('Win') !== -1) osType = 'Windows';
    if (navigator.appVersion.indexOf('Mac') !== -1) osType = 'macOS';
    if (navigator.appVersion.indexOf('X11') !== -1) osType = 'UNIX';
    if (navigator.appVersion.indexOf('Linux') !== -1) osType = 'Linux';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      osType = 'iOS Device';
    } else if (/tablet/i.test(userAgent)) {
      osType = 'Tablet';
    } else if (/mobile/i.test(userAgent)) {
      osType = 'Mobile';
    }
    return osType;
  } catch {
    return null;
  }
}

function detectOSVersion() {
  return navigator.appVersion;
}

function detectBrowser() {
  try {
    const userAgent = navigator.userAgent;
    let browserName = null;

    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = 'Chromium-based';
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = 'Firefox';
    } else if (userAgent.match(/safari/i)) {
      browserName = 'Safari';
    } else if (userAgent.match(/opr\//i)) {
      browserName = 'Opera';
    } else if (userAgent.match(/edg/i)) {
      browserName = 'Edge';
    } else if (userAgent.match(/msie|trident/i)) {
      browserName = 'Internet Explorer';
    } else {
      console.log('Browser not detected');
      console.log(userAgent);
    }

    if (isCX()) {
      browserName += ' (Chrome Extension)';
    }

    return browserName;
  } catch {
    return null;
  }
}

export function isCX() {
  return window.location.href.includes('chrome-extension://');
}

export function isProduction() {
  const BASE_URL = 'app.comprehendpt.com';
  const isProduction = window.location.origin.includes(BASE_URL);
  return isProduction;
}

export function getEnv() {
  /**
   * This function is used to get the environment of the application
   * @returns {string} - The environment of the application
   * @example
   * getEnv() // returns 'cx'
   * getEnv() // returns 'web'
   * getEnv() // returns 'electron'
   * getEnv() // returns 'reactNative'
   */

  if (isCX()) {
    return 'cx';
  }

  // Check for Electron
  if (
    typeof navigator !== 'undefined' &&
    navigator.userAgent.indexOf('Electron') !== -1
  ) {
    return 'electron';
  }

  // Check for React Native
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return 'reactNative';
  }

  // Check for web
  if (typeof window !== 'undefined' && window.location.href.includes('http')) {
    return 'web';
  }

  return 'unknown';
}

function getAppVersion() {
  try {
    return document.querySelector('#APP_VERSION').innerHTML;
  } catch {
    return null;
  }
}

/**
 * Generate a stable device fingerprint for per-device billing (e.g., Picovoice).
 * Uses stable device characteristics + localStorage for persistence.
 * @returns {string} - A stable device fingerprint hash
 */
export function getDeviceFingerprint() {
  const STORAGE_KEY = 'comprehend_device_fingerprint';

  // Check if we already have a stored fingerprint
  let storedFingerprint = localStorage.getItem(STORAGE_KEY);
  if (storedFingerprint) {
    return storedFingerprint;
  }

  // Generate fingerprint from stable device characteristics
  const components = [
    navigator.userAgent,
    navigator.language,
    window.screen.width + 'x' + window.screen.height,
    window.screen.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 'unknown',
    navigator.deviceMemory || 'unknown',
  ];

  const fingerprintString = components.join('|');

  // Simple hash function (djb2)
  let hash = 5381;
  for (let i = 0; i < fingerprintString.length; i++) {
    hash = (hash * 33) ^ fingerprintString.charCodeAt(i);
  }
  const fingerprint = 'dev_' + Math.abs(hash).toString(36);

  // Store for future consistency
  localStorage.setItem(STORAGE_KEY, fingerprint);
  return fingerprint;
}

export default async function getDeviceData() {
  const ip = await fetchIp();
  const osType = detectOSType();
  const osVersion = detectOSVersion();
  const browserName = detectBrowser();
  const appVersion = getAppVersion();
  const userAgent = navigator.userAgent;
  // console.log("IP: ", ip);
  // console.log("Browser: ", browserName);
  // console.log("OS Type: ", osType);
  // console.log("OS Version: ", osVersion);
  // console.log("User Agent: ", userAgent);
  // console.log("App Version: ", appVersion);

  return {
    IP: ip,
    osType: osType,
    osVersion: osVersion, // osVersion here is represented by appVersion for simplification
    browser: browserName,
    userAgent: userAgent,
    appVersion: appVersion,
  };
}
